/**
 * Language resources for text related to updating user profile.
 * @typedef {Object} UserProfileTextResources
 * @property {string} title - The title for updating user profile.
 * @property {string} fullName - Label for full name field.
 * @property {string} fullNamePlaceholder - Placeholder for full name field.
 * @property {string} displayName - Label for display name field.
 * @property {string} displayNamePlaceholder - Placeholder for display name field.
 * @property {string} basicInfo - Description of basic information.
 * @property {string} basics - Title for basic information section.
 * @property {string} email - Label for email field.
 * @property {string} socialLinks - Label for social links section.
 * @property {string} personalInformation - Label for personal information section.
 * @property {string} setUniqPassword - Instruction for setting a unique password.
 */

/**
 * Language resources for text related to updating user profile.
 * @type {UserProfileTextResources}
 */
export const text = {
  title: "Update Profile",
  fullName: "Full Name",
  fullNamePlaceholder: "Enter full name",
  displayName: "Display Name",
  displayNamePlaceholder: "Enter display name",
  basicInfo:
    "Basic info, like your name and address",
  basics: "Basics",
  email: "Email",
  socialLinks: "Social Links",
  personalInformation: "Personal Information",
  setUniqPassword: "Set a unique password to protect your account.",
  notification: "Notification"
};
